import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import React from 'react';
import './SelectInput.scss';

function SelectInput(props) {
    const mod_class = ['Select'].join(' ');

    return (
        <div className={mod_class}>
            <FormControl variant="outlined">
                <InputLabel id={props.id}>{props.label}</InputLabel>
                <Select
                    labelId={props.id}
                    id={props.id + '_select'}
                    value={props.value}
                    onChange={props.onChange}
                    label={props.label}
                >
                    {props.items.map((element, index) => {
                        return (
                            <MenuItem key={index} value={element.value}>
                                {element.label.toString()}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
}

export default SelectInput;
